import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.closed = {
      display: ['block', null, 'none'],
      position: 'fixed',
      top: 'var(--header-height)',
      left: 0,
      bottom: 0,
      right: 0,
      width: '100%',
      height: '100%',
      bg: 'dark',
      opacity: 0,
      pointerEvents: 'none',
      transition: 'opacity .2s cubic-bezier(0.2, 0.5, 0.2, 1)',
      willChange: 'opacity',
      zIndex: '-1',
      '&:hover': {
        cursor: 'none',
      },
    };

    this.open = {
      ...this.closed,
      opacity: 0.5,
      pointerEvents: 'auto',
      zIndex: 0,
      '&:hover': {
        cursor: `url('/svgs/overlay-close.svg') 0 0, auto`,
      },
    };
  })()
);
